



















































import { VueConstructor } from 'vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import { AddToCartProcessStateStore } from '@/components/interactions/cart/add-to-cart/add-to-cart-process-state-store'
import { noNotificationView, NotificationSectionViewFactory } from '@/components/molecules/notification-section/model/notification-section-model'
import { InstanceResolver } from '@/util/instanceResolver'
import { log } from '@/util/log'
import { PluginMixin } from '@spa/mixins/plugin'
import { Product } from '@spa/store/modules/orderHistory/types'
import { none, Option, some } from 'fp-ts/lib/Option'

type ButtonState = PendingState | ProcessingState | CompletedState
interface PendingState {
  status: 'pending'
  errorMessage?: string
}
interface ProcessingState {
  status: 'processing'
}
interface CompletedState {
  status: 'completed'
}

@Component
export default class OrderHistoryAddToCartButton extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  readonly product: Product

  @Prop({ required: true })
  readonly addToCartProcessStateStore: AddToCartProcessStateStore

  state: ButtonState = {
    status: 'pending',
  }

  get addToCartButtonEnabled(): boolean {
    return this.addToCartProcessStateStore.processState.isPending()
  }

  /**
   * SINGLEのときsingle brandを返す
   * MULTIのときはnoneを返す
   */
  get getSingleBrand(): Option<string> {
    if (!InstanceResolver.isSingle()) {
      return none
    }

    return some(InstanceResolver.getSingleBrand())
  }

  get notificationSectionView(): VueConstructor {
    if (this.state.status !== 'pending' || !this.state.errorMessage) {
      return noNotificationView
    }

    return NotificationSectionViewFactory.create('caution', {
      type: 'with-icon',
      body: this.state.errorMessage,
    })
  }

  async addToCart() {
    this.state = {
      status: 'processing',
    }

    // 型にあわせてガードだけ入れるが、brandEnglishNameがないということは基本起こり得ないらしい
    if (!this.product.brandEnglishName) {
      this.state = {
        status: 'pending',
        errorMessage: 'この商品はカートに入れられません。',
      }

      return
    }

    await this.addToCartProcessStateStore.start(
      this.product.brandEnglishName,
      this.product.skuId,
      this.product.unitCount
    ).then((result) => {
      result.fold(
        (error) => {
          log.error({ error: error.error })
          this.state = {
            status: 'pending',
            errorMessage: error.displayMessages.join('<br>'),
          }
        },
        () => {
          this.state = {
            status: 'completed',
          }

          // EcHeaderのカート点数を更新するためにカートのsummaryをリロード
          // 他ページで読み込んだ古いgroupsが存在する可能性を考慮してinvalidate
          // brandEnglishNameが必要だがMULTI環境ではブランドが確定しないのでSINGLE環境時のみリロードする
          this.getSingleBrand.map((brandName) => {
            this.$store.dispatch('cart/invalidateLoadedGroups')
            this.$store.dispatch('cart/loadSummaryByBrand', { brandName, force: true })
          })
        }
      )
    })
  }
}
